import { useContext } from 'react'
import { Accordion } from 'component-library'
import { useAuth0 } from '@auth0/auth0-react'
import { sendCustomGAEvent } from 'shared-utilities'
import './DatasetSourceCode.scss'
import sourceCodeTabContent from '../../../content/sourceCodeTab'
import MarkdownText from '../MarkdownText/MarkdownText'
import { DatasetContext } from '../../context'
import '../../styles/button.scss'

const DatasetSourceCode = ({
  slug,
  sourceCodeLink,
}: {
  slug: string
  sourceCodeLink?: string | null
}) => {
  const { user } = useAuth0()
  const { downloadName } = useContext(DatasetContext)
  const selectedContent = sourceCodeTabContent[slug]
    ? sourceCodeTabContent[slug]
    : sourceCodeTabContent['other']

  return (
    <section className="DatasetSourceCode" data-testid="dataset-source-code">
      <Accordion
        isExpandedDefault={true}
        itemTitle={selectedContent.accordionTitle}
        itemContent={
          <div>
            <div data-testid="markdown-text">
              <MarkdownText
                className="font-roboto text-[15px]"
                text={selectedContent.text}
              />
            </div>
            <div className="w-full flex justify-end mt-6">
              {sourceCodeLink ? (
                <a
                  href={sourceCodeLink}
                  target="_blank"
                  rel="noreferrer"
                  className="Button Button__secondary--blue"
                  data-testid="source-code-link"
                  onClick={() => {
                    sendCustomGAEvent('view-source-code', {
                      event_category: 'dataset',
                      event_label: `${downloadName}`,
                      value: JSON.stringify({
                        id: user?.sub || '',
                      }),
                    })
                  }}
                >
                  <i className="bx bxl-github text-lg"></i> View source code
                </a>
              ) : null}
            </div>
          </div>
        }
      />
    </section>
  )
}

export default DatasetSourceCode
